import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom"; // Ensure correct import for router functions
import { fetchPuja, addPuja, deletePuja } from "../../service/fetchAPI"; // Import all API functions
import UserTable from "./User-table-data"; // Assuming this component exists
import { Input, Label } from "../form-field/form-field"; // Assuming these components exist

const PujaList = () => {
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false); // For loading state
  const [error, setError] = useState(null); // For error messages
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const search = searchParams.get("search") || "";

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await fetchPuja(search); // Fetch data based on search query
        setFilteredData(data);
      } catch (error) {
        console.error("Error fetching puja data:", error);
        setError("Failed to load pujas. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [search]);

  const handleAddPuja = async () => {
    try {
      const newPuja = {
        name: "New Puja",
        description: "Default description",
      };
      await addPuja(newPuja); // Add Puja through API
      alert("Puja added successfully");
      const updatedData = await fetchPuja(search); // Refetch data to reflect changes
      setFilteredData(updatedData);
    } catch (error) {
      console.error("Error adding puja:", error);
      alert("Failed to add puja. Please try again.");
    }
  };

  const handleDeletePuja = async (puja_category_id) => {
    try {
      await deletePuja(puja_category_id); // Delete puja by ID
      alert("Puja deleted successfully");
      setFilteredData((prevData) =>
        prevData.filter((puja) => puja.puja_category_id !== puja_category_id)
      ); // Update state without refetching
    } catch (error) {
      console.error("Error deleting puja:", error);
      alert("Failed to delete puja. Please try again.");
    }
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    const params = new URLSearchParams(searchParams);
    params.set("search", value);
    navigate(`/admin/users?${params.toString()}`); // Update the URL with the search query
  };

  return (
    <div className="puja-list">
      <h1>Puja Management</h1>

      <div className="controls">
        <Label htmlFor="search">Search</Label>
        <Input
          id="search"
          type="text"
          placeholder="Search pujas..."
          value={search}
          onChange={handleSearchChange}
        />
        <button className="add-button" onClick={handleAddPuja}>
          + Add New Puja
        </button>
      </div>

      {loading && <p>Loading...</p>}
      {error && <p className="error">{error}</p>}

      <UserTable
        data={filteredData}
        onDelete={handleDeletePuja} // Pass delete handler to the table
      />
    </div>
  );
};

export default PujaList;
